import React, { useState, useContext } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import '../styles/Auth.css';

const MFAVerify = () => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { verifyMFA } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const tempToken = location.state?.tempToken;

  if (!tempToken) {
    return <Navigate to="/login" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (code.length !== 6) {
      setError('Please enter a valid 6-digit code');
      return;
    }

    setLoading(true);

    const result = await verifyMFA(code, tempToken);

    if (result.success) {
      const role = result.user?.role;
      navigate(['ADMIN', 'IT'].includes(role) ? '/admin' : '/dashboard');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Staff IT</h1>
        <h2>Verify Your Identity</h2>
        <p>Enter the 6-digit code from your authenticator app or use a backup code.</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="code">Authentication Code</label>
            <input
              type="text"
              id="code"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              placeholder="000000"
              maxLength="6"
              required
              disabled={loading}
              style={{ textAlign: 'center', letterSpacing: '5px', fontSize: '18px' }}
            />
          </div>

          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Verifying...' : 'Verify'}
          </button>
        </form>

        <p className="auth-toggle">
          <a href="/login">Back to Login</a>
        </p>
      </div>
    </div>
  );
};

export default MFAVerify;
